// extracted by mini-css-extract-plugin
export default {"content":"ErrorPage_content__Kihvv","links":"ErrorPage_links__vdeK1"};